import _find from 'lodash/find';
import _first from 'lodash/first';
import _groupBy from 'lodash/groupBy';
import _isEmpty from 'lodash/isEmpty';
import _keyBy from 'lodash/keyBy';
import _merge from 'lodash/merge';
import _pick from 'lodash/pick';
import _remove from 'lodash/remove';
import _uniq from 'lodash/uniq';
import _values from 'lodash/values';

import { cachedPromise, remember, S3_listObjectsV2, url } from './utilities';
import { CONFIG } from '../config/config';

export const ListingPromise = cachedPromise('ListingPromise', 300, function (resolve, reject) {
  var bucket_contents = [];
  var all_country_codes = [];
  var all_indicator_ids = [];

  function retrieveS3(callback, ContinuationToken) {
    console.log('retrieveS3 is running' + new Date());
    var listObjectsParams = {
      Bucket: env.S3_BUCKET,
      Prefix: env.MODELED_SURFACES_S3_PATH,
    };

    if (typeof ContinuationToken === 'string') {
      listObjectsParams.ContinuationToken = ContinuationToken;
    }

    S3_listObjectsV2(listObjectsParams, function (err, data) {
      if (err) {
        console.error(err);
      } else {
        bucket_contents = bucket_contents.concat(data.Contents);
        if (data.IsTruncated) {
          retrieveS3(callback, data.NextContinuationToken);
        } else {
          callback(bucket_contents);
        }
      }
    });
  }

  retrieveS3(function (items) {
    var items = items.map(function (v) {
      var i = {};
      i.path = v.Key.replace(env.MODELED_SURFACES_S3_PATH, '');
      i.prefix = i.path.split(/[\.\/]/).slice(0, 1)[0];
      var country_match = i.prefix.match(/^([a-z]+)?[0-9]/i);
      i.country_id = country_match !== null && country_match.length > 1 ? country_match[1] : null;
      if (i.country_id) all_country_codes.push(i.country_id);

      var year_match = i.prefix.match(/^[a-z]+?([0-9]+?)[a-z]/i);
      i.year = year_match !== null && year_match.length > 1 ? year_match[1] : null;

      var survey_type_match = i.prefix.match(/(dhs|mis)/i);
      i.type = survey_type_match !== null && survey_type_match.length > 1 ? survey_type_match[1] : null;

      var indicator_id_match = i.prefix.match(/^.*?_(.*?)_/i);
      i.sdr_id = null;
      i.indicator_id = null;

      if (indicator_id_match !== null && indicator_id_match.length > 1) {
        i.sdr_id = indicator_id_match[1];
        i.indicator_id = [];
        i.indicator_id.push(i.sdr_id.slice(0, 2));
        i.indicator_id.push(i.sdr_id.slice(2, 6));
        i.indicator_id.push(i.sdr_id.slice(6, 7));
        i.indicator_id.push(i.sdr_id.slice(-3));
        i.indicator_id = i.indicator_id.join('_');
      }
      if (i.indicator_id) all_indicator_ids.push(i.indicator_id);

      i.subgroup = 'misc';
      if (/^.*?MEAN.*?\.(png)$/i.test(i.path)) i.subgroup = 'featured_image';
      if (/\.(jpg|jpeg|tif|svg)$/i.test(i.path)) i.subgroup = 'images';
      else if (/\.(zip)$/i.test(i.path)) i.subgroup = 'zip';
      else if (/\.(pdf)$/i.test(i.path)) i.subgroup = 'pdfs';
      else if (/\.(txt)$/i.test(i.path)) i.subgroup = 'txts';

      i.slug = i.country_id && i.year && i.type ? [i.country_id, i.year, i.type].join('|') : 'misc';

      return i;
    });

    var surveys = _groupBy(items, 'slug');
    all_country_codes = _uniq(all_country_codes);
    all_indicator_ids = _uniq(all_indicator_ids);

    var promises = [];
    promises.push(
      remember(
        CONFIG.dhsAPI +
          'indicators?apiKey=' +
          CONFIG.apiKey +
          '&perPage=5000&indicatorIds=' +
          all_indicator_ids.join(',')
      )
    );
    promises.push(remember(CONFIG.dhsAPI + 'countries?countryIds=' + all_country_codes.join(',')));

    Promise.all(promises).then(function (responses) {
      console.log(responses);

      let _indicators = _keyBy(responses[0].Data, 'IndicatorId');
      let _countries = _keyBy(responses[1].Data, 'DHS_CountryCode');

      surveys.misc = surveys.misc.map(function (v) {
        var reg = new RegExp('(' + all_country_codes.join('|') + ')', 'i');
        var matches = v.prefix.match(reg);
        v.country_id = matches && matches.length > 1 ? matches[1] : null;
        return v;
      });
      var return_surveys = [];
      for (var groupname in surveys) {
        if (groupname != 'misc') {
          var first_item = _first(surveys[groupname]);
          var survey_obj = _pick(first_item, ['country_id', 'slug', 'type', 'year']);
          survey_obj.all_downloads_link = CONFIG.base_url + survey_obj.country_id + '_package_all.zip';
          survey_obj.country = _countries[survey_obj.country_id];
          survey_obj.selected = false;
          survey_obj.survey_name = survey_obj.year + ' ' + survey_obj.type;
          survey_obj.name = survey_obj.country.CountryName + ' ' + survey_obj.survey_name;

          survey_obj.indicators = _values(_groupBy(surveys[groupname], 'indicator_id')).map(function (
            indicator_items,
            ind
          ) {
            var indicator_obj = {};
            indicator_obj.country_id = indicator_items[0].country_id;
            indicator_obj.indicator_id = indicator_items[0].indicator_id;
            indicator_obj.id = indicator_obj.indicator_id;
            indicator_obj.sdr_id = indicator_items[0].sdr_id;
            indicator_obj.image = (_find(indicator_items, { subgroup: 'featured_image' }) || {}).path;
            if (!indicator_obj.image) return null;
            indicator_obj.image_url = url(indicator_obj.image);
            indicator_obj.zip = (_find(indicator_items, { subgroup: 'zip' }) || {}).path;
            indicator_obj.zip_url = url(indicator_obj.zip);
            indicator_obj.package_name = indicator_obj.zip;
            indicator_obj.api_link =
              'https://api.dhsprogram.com/rest/dhs/data?countryIds=' +
              indicator_obj.country_id +
              '&surveyYear=' +
              survey_obj.survey_name.slice(0, 4) +
              '&indicatorIds=' +
              indicator_obj.indicator_id +
              '&perpage=300&f=html';
            indicator_obj.tracking_string = indicator_obj.image.split('_').slice(0, 2).join('_');
            indicator_obj.selected = ind === 0;
            _merge(indicator_obj, _indicators[indicator_obj.indicator_id]);
            indicator_obj.group = indicator_obj.Level1 + ': ' + indicator_obj.Level2;

            return indicator_obj;
          });
          _remove(survey_obj.indicators, _isEmpty);

          return_surveys.push(survey_obj);

          surveys[groupname] = _groupBy(surveys[groupname], 'indicator_id');
          for (var group_indicator_id in surveys[groupname]) {
            var first_item = surveys[groupname][group_indicator_id][0];

            surveys[groupname][group_indicator_id].country_id = first_item.country_id;
            surveys[groupname][group_indicator_id].indicator_id = first_item.indicator_id;
            surveys[groupname][group_indicator_id].sdr_id = first_item.sdr_id;
            surveys[groupname][group_indicator_id].image = (
              _find(surveys[groupname][group_indicator_id], { subgroup: 'featured_image' }) || {}
            ).path;
            surveys[groupname][group_indicator_id].zip = (
              _find(surveys[groupname][group_indicator_id], { subgroup: 'zip' }) || {}
            ).path;
          }
        }
      }
      surveys = null; // free up memory

      resolve({
        surveys: return_surveys,
        all_indicator_ids: all_indicator_ids,
        all_country_codes: all_country_codes,
      });
    });
  });
}); // close Listing Promise
